import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';

let getHomePageDate =  (homeData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'home/gethomedata', homeData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let submitHomePageDate =  (homeData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'home/submitsurvey', homeData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let saveOrderDashboardData =  (homeData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'home/submitdashboardonly', homeData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let convertSurveyList = (surveyListData) => { 
    const convertedData = surveyListData.map((item) => ({
        image: `${item.survey.shortCode}.png`,
        title: item.survey.name.toUpperCase(),
        value: item.value,
        survey_id: item.survey._id,
        _id: item._id,
        shortCode: item.survey.shortCode,
        survey: {
          name: item.survey.name,
          shortCode: item.survey.shortCode,
          _id: item.survey._id
        }
      }));

      return convertedData;
}


const getUniqueCounty = (districtDropdownData) => {
    const uniqueCountyObjects = Array.from(
      new Map(districtDropdownData.map(obj => [obj.county_id, obj])).values()
    );
    return uniqueCountyObjects;
  }

  const getdistrictsofselectedcounty = (districtDropdownData, countyId) => {
    return  districtDropdownData.filter(obj => obj.county_id == countyId);
  }

const homeService = {
    getHomePageDate,
    convertSurveyList,
    getUniqueCounty,
    getdistrictsofselectedcounty,
    submitHomePageDate,
    saveOrderDashboardData
}

export default homeService 